import { DownOutlined, UpOutlined } from '@ant-design/icons';
import useDebounce from '@root/core/hooks/useDebounce';
import useTranslate from '@root/core/hooks/useTranslate';
import ReturnServices from '@root/modules/Sellers/Return/services/return';
import { ReturnType } from '@root/modules/Sellers/Shipping/enum';
import { formatDateTime } from '@root/utils/helpers/formatDate';
import { Button, Card, DatePicker, Menu, Table } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import type { Moment } from 'moment';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import DropdownButton from '../../../Inquiry/components/DropdownButton';
import SearchBox from '../../../Inquiry/components/Search';
import BreadcrumbList from '../../../Stock/components/Breadcrumb';

interface DataType {
  key: React.Key;
  productName: string;
  sku: number;
  eanUpc: number;
  stockQuantity: number;
  progressStatus: string;
  updated_at: Date;
  setSelectedRow: React.Dispatch<React.SetStateAction<React.Key[]>>;
}

const ReturnNotAccess = () => {
  const [t] = useTranslate();
  const history = useHistory();
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [listQuotation, setListQuotation] = useState([] as any);
  const [listExcel, setListExcel] = useState([] as any);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItem, setTotaItem] = useState();
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState();
  const [limit, setLimit] = useState();
  const [refresh, setRefresh] = useState(false);
  const [status, setStatus] = useState('');
  const [labelStatus, setLabelStatus] = useState({
    key: '1',
    label: t('seller:button:select')
  } as any);
  const [labelType, setLabelType] = useState({
    key: '2',
    label: t('seller:button:select')
  } as any);
  const [proName, setProName] = useState('');
  const [valueSearch, setValueSearch] = useState('');
  const debounc = useDebounce(valueSearch, 1000);
  const [sort, setSort] = useState(true);
  const [dateValue, setDateValue] = useState<[string, string]>();
  const [dates, setDates] = useState<[Moment | null, Moment | null] | null>(
    null
  );

  const fromDt: string = (dates && dates[0]?.format('YYYY/MM/DD')) || '';
  const toDt: string = (dates && dates[1]?.format('YYYY/MM/DD')) || '';
  const [type, setType] = useState('');
  const [listStatus, setListStatus] = useState<
    {
      code: string;
      name: string;
    }[]
  >([]);
  const [returnType, setReturnType] = useState(
    [ReturnType.Import, ReturnType.Stock].join()
  );
  const [isSearch, setIsSearch] = useState('');

  const columns: ColumnsType<DataType> = [
    {
      title: 'No',
      dataIndex: 'key'
    },
    {
      title: '분류',
      dataIndex: 'type'
    },
    {
      title: '상품명',
      dataIndex: 'productName'
    },

    {
      title: 'SKU',
      dataIndex: 'sku'
    },
    {
      title: '물류센터명',
      dataIndex: 'logistic'
    },
    {
      title: '상태',
      dataIndex: 'status'
    },
    {
      title: '사유 ',
      dataIndex: 'reason'
    },

    {
      title: (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          업데이트일
          {!sort ? (
            <UpOutlined
              style={{ marginLeft: '15px' }}
              onClick={() => setSort(true)}
            />
          ) : (
            <DownOutlined
              style={{ marginLeft: '15px' }}
              onClick={() => {
                setSort(false);
              }}
            />
          )}
        </div>
      ),
      dataIndex: 'updated_at'
    }
  ];
  const BreadcrumbReturn = [
    {
      tittle: '반환/폐기 관리',
      url: ''
    },
    {
      tittle: '반환 조회',
      url: ''
    }
  ];
  const BreadcrumbReturnDisposal = [
    {
      tittle: '반환/폐기 관리',
      url: ''
    },
    {
      tittle: '폐기 조회',
      url: ''
    }
  ];
  const listStatusTmp = {
    return: [
      {
        code: 'Request',
        name: '배송 요청'
      },
      {
        code: 'Inprogress',
        name: '배송중'
      },
      {
        code: 'Completed',
        name: '배송 완료'
      }
    ],
    disposal: [
      {
        code: 'Request',
        name: '폐기 요청'
      },
      {
        code: 'Inprogress',
        name: '폐기중'
      },
      {
        code: 'Completed',
        name: '폐기 완료'
      }
    ]
  };
  const listType = [
    {
      code: 'Import',
      type: '입고'
    },
    {
      code: 'Order',
      type: '주문'
    },
    {
      code: 'Stock',
      type: '재고'
    }
  ];
  const getStatus = (e: any) => {
    setStatus(e.key);
    setLabelStatus({ key: e.key, label: e.domEvent.target.innerText });
  };

  const getProductName = (e: any) => {
    setProName(e.key);
    setLabelType({ key: e.key, label: e.domEvent.target.innerText });
  };

  const onChangeState = (name: string, value: string) => {
    setValueSearch(() => {
      return value;
    });
  };
  const getDate = (value: [string, string]) => {
    setDateValue(value);
  };

  const listLabel = [
    {
      id: 2,
      labelTitle: t('seller:button:select'),
      listMenu: (
        <Menu
          onClick={getProductName}
          items={listStatus.map((l, idx) => ({
            label: l.name,
            key: l.code.toLowerCase()
          }))}
        />
      )
    },
    {
      id: 1,
      labelTitle: t('seller:button:select'),
      listMenu: (
        <Menu
          onClick={getStatus}
          items={[
            {
              label: '상품명',
              key: 'productName'
            },
            {
              type: 'divider'
            },
            {
              label: '물류센터명',
              key: 'warehouseName'
            },
            {
              type: 'divider'
            },
            {
              label: 'SKU',
              key: 'sku'
            }
          ]}
        />
      )
    }
  ];

  const rowSelection = {
    selectedRowKeys,
    preserveSelectedRowKeys: true,
    onChange: (selectedRowKeyss: React.Key[], selectedRows: DataType[]) => {
      setListExcel(selectedRows);
      setSelectedRowKeys(selectedRowKeyss);
    },
    getCheckboxProps: (record: DataType) => ({
      // disabled: record.productName === "Disabled User", // Column configuration not to be checked
      name: record.productName
    })
  };

  const { RangePicker } = DatePicker;
  const dateFormat = 'YYYY/MM/DD';

  const handelExportExcel = async (
    productName: string,
    sort: boolean,
    fromDt: string,
    toDt: string,
    valueSearchReturn: string,
    status: string,
    typeAPI: string
  ) => {
    if (selectedRowKeys.length > 0) {
      let selected = selectedRowKeys.map((item) => Number(item));
      const responseById = await ReturnServices.exportExcelById(selected);
      const outputFilename = `Product_${new Date().getTime()}.xlsx`;
      const url = URL.createObjectURL(new Blob([responseById]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', outputFilename);
      document.body.appendChild(link);
      link.click();
    } else {
      const productName = proName;
      const response = await ReturnServices.exportExcelAll({
        productName,
        sort,
        fromDt,
        toDt,
        valueSearch,
        status,
        typeAPI,
        returnType
      });
      const outputFilename = `Return_disposal_managment(1)_240406T9g6QGJSxyR.xlsx`;
      const url = URL.createObjectURL(new Blob([response]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', outputFilename);
      document.body.appendChild(link);
      link.click();
    }
  };

  const listReturn = async (
    page: any,
    sort: boolean,
    fromDt: string,
    toDt: string,
    valueSearch: any,
    status: any,
    productName: any,
    typeAPI: string
  ) => {
    if (!!type) {
      setLoading(true);
      const temp = await ReturnServices.getListReturn({
        page,
        sort,
        fromDt,
        toDt,
        valueSearch,
        status,
        productName,
        typeAPI,
        returnType
      });
      let listReturn = temp.data.map((item: any, index: number) => {
        return {
          ...item,
          updated_at: formatDateTime(item.updatedAt),
          // updated_at: moment(item.updatedAt)
          //   .utc(true ?? 9)
          //   .format('YYYY.MM.DD hh:mm:ss A'),
          key: item.returnId,
          sku: item.productSku,
          logistic: item.warehouseName,
          status: listStatus.find((x) => x.code === item.status)?.name,
          type: listType.find((x) => x.code === item.type)?.type
        };
      });

      setListQuotation(listReturn);
      setTotalPages(temp.meta.totalPages);
      setCurrentPage(temp.meta.currentPage);
      setLimit(temp.meta.itemsPerPage);
      setTotaItem(temp.meta.totalItems);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!!valueSearch && !!status) setIsSearch(valueSearch);
    else if (!!isSearch && !valueSearch) {
      setIsSearch('');
    }
  }, [debounc, status]);

  useEffect(() => {
    setRefresh(false);
    listReturn(1, sort, fromDt, toDt, valueSearch, status, proName, type);
  }, [sort, fromDt, toDt, proName, isSearch, type]);

  const location = useLocation();
  useEffect(() => {
    if (location.pathname === '/admin/seller/return') {
      setType('return');
      setListStatus(listStatusTmp.return);
    } else {
      setType('disposal');
      setListStatus(listStatusTmp.disposal);
    }
    setDates(null);
    setLabelType({ key: '2', label: t('seller:button:select') });
    setLabelStatus({
      key: '1',
      label: t('seller:button:select')
    });
    setValueSearch('');
    setProName('');
    setStatus('');
    setRefresh(true);
  }, [location]);

  return (
    <div>
      <BreadcrumbList
        listBreadcrumb={
          type === 'return' ? BreadcrumbReturn : BreadcrumbReturnDisposal
        }
      />
      <div className="admin-container">
        <Card
          bordered={false}
          className="admin-card"
          style={{
            minHeight: '80vh',
            background: 'none'
          }}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          ></div>
          <div className="control">
            <RangePicker
              onChange={(date: any, dateString: [string, string]) => {
                setDates(date);
              }}
              value={dates}
              placeholder={['YYYY.MM.DD', 'YYYY.MM.DD']}
              format={dateFormat}
            />
            {listLabel.map((item) => {
              return (
                <DropdownButton
                  key={item.id}
                  label={item.id === 1 ? labelStatus.label : labelType.label}
                  menu={item.listMenu}
                />
              );
            })}
            <SearchBox
              refresh={refresh}
              type
              onChange={(e: any) =>
                onChangeState('Value Search', e.target.value)
              }
            />
          </div>
          <div className="table">
            <div>
              <div
                style={{
                  marginBottom: 16,
                  display: 'flex',
                  justifyContent: 'space-between',
                  paddingTop: 16
                }}
              >
                <div className="table__head">
                  <span style={{ marginLeft: 8 }}>
                    {type === 'return' ? '총 반환' : '총 폐기'} {totalItem}
                  </span>
                  <span className="table__head --right">
                    {type === 'return' ? '선택 반환' : '선택 폐기'}
                    {listExcel.length}
                  </span>
                </div>

                <div>
                  <Button
                    className="downExcel"
                    onClick={() => {
                      handelExportExcel(
                        proName,
                        sort,
                        fromDt,
                        toDt,
                        valueSearch,
                        status,
                        type
                      );
                    }}
                  >
                    {t('common:download')}
                  </Button>
                </div>
              </div>
              <Table
                loading={loading}
                columns={columns}
                dataSource={listQuotation}
                rowSelection={rowSelection}
                pagination={{
                  total: totalPages * 10,
                  current: currentPage,
                  showSizeChanger: false,
                  onChange: (page, limit) => {
                    listReturn(
                      page,
                      sort,
                      fromDt,
                      toDt,
                      valueSearch,
                      status,
                      proName,
                      type
                    );
                  }
                }}
                onRow={(item) => {
                  return {
                    onClick: () => {
                      type === 'return'
                        ? history.push(`/admin/seller/return/${item.key}`)
                        : history.push(
                            `/admin/seller/return-disposal/${item.key}`
                          );
                    }
                  };
                }}
              />
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default ReturnNotAccess;
